import styles from "./Library.module.css";
import { FolderFeatureHighlight } from "shared/TeamsAnnouncement/TeamFeatureHighlights";
import { IconButton } from "components/Button/IconButton";
import { IconFolderPlus } from "components/Icons/IconFolderPlus";
import { CreateFolderDialogContent } from "./CreateFolder/CreateFolderDialogContent";
import { Modal } from "components/Modal/Modal";
import { SearchAndFilters } from "./SearchAndFilters";
import { TabList } from "components/Tabs/TabList";
import { TabLink } from "components/Tabs/TabLink";
import { useActiveTab } from "./useActiveTab";
import { useActiveContext } from "shared/ContextSwitcher/store";
import { HoverPopover } from "components/HoverPopover/HoverPopover";

interface Props {
  refetchFolders: () => Promise<void>;
  foldersCount: number;
}

export function Toolbar(props: Props) {
  const { activeTab, getTabUrl } = useActiveTab();
  const activeContext = useActiveContext();
  const serviceTierMaxFolders = activeContext?.serviceTier.maxFolders ?? 0;
  const isFolderLimitReached = props.foldersCount >= serviceTierMaxFolders;

  return (
    <div className={styles.toolbar}>
      <TabList size="M">
        <TabLink active={activeTab === "library"} href={getTabUrl("library")}>
          Library
        </TabLink>
        <TabLink active={activeTab === "queries"} href={getTabUrl("queries")}>
          Queries
        </TabLink>
        <TabLink
          active={activeTab === "dashboards"}
          href={getTabUrl("dashboards")}
        >
          Dashboards
        </TabLink>
      </TabList>

      <div className={styles.rightSide}>
        <Modal
          size="M"
          label="Create folder"
          content={({ close }) => (
            <CreateFolderDialogContent
              onDismiss={close}
              refetchFolders={props.refetchFolders}
            />
          )}
          trigger={({ onClick }) => (
            <FolderFeatureHighlight>
              <HoverPopover
                position="below-center"
                enabled={isFolderLimitReached}
                content={() => (
                  <div className={styles.limitReachedTooltip}>
                    You've reached the folder limit included in your plan.{" "}
                    <a className={styles.upgradeLink} href="/pricing">
                      Upgrade plan
                    </a>
                  </div>
                )}
              >
                <IconButton
                  theme="tertiary"
                  size="M"
                  onClick={onClick}
                  disabled={isFolderLimitReached}
                >
                  <IconFolderPlus />
                </IconButton>
              </HoverPopover>
            </FolderFeatureHighlight>
          )}
        />

        <SearchAndFilters activeTab={activeTab} />
      </div>
    </div>
  );
}
